"use client";

import { forwardRef } from "react";

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  unit?: string;
  hint?: string;
  id: string;
}

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ label, unit, hint, id, className = "", ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        <label
          htmlFor={id}
          className="text-[10px] font-bold tracking-[0.08em] uppercase text-slate-500 dark:text-slate-400 select-none"
        >
          {label}
          {props.required && (
            <span className="ml-1 text-sky-600 dark:text-sky-400">*</span>
          )}
        </label>
        <div className="relative flex items-center w-full">
          <input
            ref={ref}
            id={id}
            type={props.type || "number"}
            className={`flex h-12 w-full rounded-lg border px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-50 border-slate-200 dark:border-slate-800 transition-colors focus:outline-none focus:ring-1 focus:ring-accent focus:border-accent appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${
              unit ? "pr-12" : ""
            } ${className}`}
            {...props}
          />
          {unit && (
            <span className="absolute right-3 text-[10px] font-mono font-bold tracking-wider text-slate-400 dark:text-slate-500 uppercase select-none pointer-events-none">
              {unit}
            </span>
          )}
        </div>
        {hint && (
          <p className="text-xs text-slate-450 dark:text-slate-500 font-medium">
            {hint}
          </p>
        )}
      </div>
    );
  }
);

InputField.displayName = "InputField";
export default InputField;
